import React from 'react';
import DisconnectedStatusCard from './DisconnectedStatusCard';
import '../../styles/Home.css';

/**
 * Section invitant à se connecter (utilisateur non authentifié)
 *
 * @component
 * @param {Object} props
 * @param {Function} props.onLogin - Ouvre la modal de connexion
 * @returns {JSX.Element}
 */
const ConnectionStatusSection = ({ onLogin }) => {
  return (
    <section className="status-section">
      <div className="connection-status-wrapper">
        <DisconnectedStatusCard onLogin={onLogin} />
      </div>
    </section>
  );
};

export default ConnectionStatusSection;
